// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";

import moment from "moment";
import { getWhatsappTemplateHistory } from "network/service";
import { useNavigate } from "react-router-dom";

import * as XLSX from 'xlsx';
import TableData from "./data";
import AddCampaignPopup from "./components/AddCampaignPopup";


function Campaigns() {

    const initialFilters = JSON.parse(localStorage.getItem('filters')) || {
        from: new Date(),
        to: new Date(),
        status: [],
    };
    const [loading, setLoading] = useState(false);
    const [dElems, setDelems] = useState([]);
    const [data, setData] = useState([]);
    const { formCampaignRows, campaignHeaders } = TableData();
    const [addcampaignPopup, setAddCampaignPopup] = useState({ open: false, details: null });

    const fetchAllTemplates = () => {
        getWhatsappTemplateHistory(`__order=createdAt_-1`).then((resp) => {
            setData(resp.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    useEffect(() => {
        fetchAllTemplates();
    }, [setData]);


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}><Grid container spacing={6}>
                {addcampaignPopup.open && <AddCampaignPopup isopen={addcampaignPopup.open} details={addcampaignPopup.details} handleclose={() => { setAddCampaignPopup({ open: false, details: null }) }} handlesuccess={() => { fetchAllTemplates(); setAddCampaignPopup({ open: false, details: null }) }} />}
                <Grid item xs={12}>
                    <Card>
                        <MDBox
                            mx={2}
                            mt={-3}
                            py={3}
                            px={2}
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                        >
                            <MDTypography variant="h6" color="white">
                                Campaigns Table
                            </MDTypography>
                        </MDBox>
                        <MDBox
                            mx={2}
                            mt={0}
                            py={2}
                            px={0}
                            borderRadius="lg"
                            alignSelf="flex-end"
                        >
                            <MDButton variant="gradient" color="info" style={{ margin: 5 }}
                                onClick={async () => {
                                    setAddCampaignPopup({ open: true, details: null });
                                }}>
                                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                &nbsp;Add Campaign
                            </MDButton>
                        </MDBox>
                        <MDBox pt={0}>
                            <DataTable
                                table={{ columns: campaignHeaders, rows: formCampaignRows(data) }}
                                canSearch
                            />
                        </MDBox>
                    </Card>
                </Grid>
            </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default Campaigns;
